export const creativeConfig = {
  name: '创意管理',
  description: '从想法到实现的完整流程',
  icon: 'BulbOutlined',
  bgColor: '#FFD700',
  iconColor: '#333333',
  
  // API端点
  apiEndpoints: {
    ideas: '/creative',
    createIdea: '/creative',
    updateIdea: '/creative',
    deleteIdea: '/creative',
    types: '/creative/types',
    createType: '/creative/types',
    updateType: '/creative/types',
    deleteType: '/creative/types',
    stats: '/creative/stats'
  },

  // 创意类型定义
  ideaTypes: [
    {
      key: 'product',
      name: '产品创意',
      icon: '🔧',
      color: '#1890FF',
      description: '新产品或服务的设计和开发'
    },
    {
      key: 'process',
      name: '流程优化',
      icon: '⚙️',
      color: '#52C41A',
      description: '工作流程和操作流程的改进'
    },
    {
      key: 'marketing',
      name: '营销创意',
      icon: '📢',
      color: '#FAAD14',
      description: '营销策略和推广方案'
    },
    {
      key: 'technology',
      name: '技术创新',
      icon: '💻',
      color: '#722ED1',
      description: '技术解决方案和工具开发'
    },
    {
      key: 'business',
      name: '商业模式',
      icon: '💼',
      color: '#F5222D',
      description: '商业模式的创新和改进'
    },
    {
      key: 'service',
      name: '服务创新',
      icon: '🎯',
      color: '#13C2C2',
      description: '客户服务和用户体验改进'
    }
  ],

  // 创意来源
  ideaSources: [
    { key: 'brainstorm', name: '头脑风暴', icon: '🧠' },
    { key: 'observation', name: '日常观察', icon: '👀' },
    { key: 'feedback', name: '用户反馈', icon: '💬' },
    { key: 'trend', name: '技术趋势', icon: '📈' },
    { key: 'competitor', name: '竞品分析', icon: '🔍' },
    { key: 'inspiration', name: '灵感启发', icon: '✨' },
    { key: 'problem', name: '问题驱动', icon: '❓' },
    { key: 'opportunity', name: '机会发现', icon: '🎯' }
  ],

  // 评估标准
  evaluationCriteria: [
    { key: 'feasibility', name: '可行性', icon: '✅' },
    { key: 'cost', name: '成本效益', icon: '💰' },
    { key: 'innovation', name: '创新性', icon: '💡' },
    { key: 'value', name: '价值创造', icon: '📈' },
    { key: 'risk', name: '风险评估', icon: '⚠️' }
  ],

  // 实施阶段
  implementationStages: [
    { key: 'concept', name: '概念阶段', icon: '📝' },
    { key: 'prototype', name: '原型开发', icon: '🔨' },
    { key: 'testing', name: '测试验证', icon: '🧪' },
    { key: 'pilot', name: '试点实施', icon: '🚀' },
    { key: 'full_launch', name: '全面推广', icon: '🌟' },
    { key: 'completed', name: '已完成', icon: '✅' }
  ],

  // 创意管理TIPS
  creativeManagementTips: {
    title: '创意管理五大流程',
    description: '从想法到实现的完整管理流程',
    process: [
      {
        step: 1,
        title: '创意产生',
        icon: '💡',
        description: '头脑风暴、日常工作观察、用户反馈、技术趋势等',
        details: '源源不断地产生新点子，保持开放和创新的思维'
      },
      {
        step: 2,
        title: '创意收集',
        icon: '📥',
        description: '把零散的想法记录下来，集中管理',
        details: '用笔记本、意见箱、在线系统等方式收集和整理创意'
      },
      {
        step: 3,
        title: '创意筛选与评估',
        icon: '🔍',
        description: '通过标准（可行性、成本、创新性、价值、风险）进行筛选',
        details: '去掉不切实际的，留下有潜力的创意进行深入评估'
      },
      {
        step: 4,
        title: '创意孵化与实施',
        icon: '🚀',
        description: '做小实验、开发原型（MVP），逐步落地',
        details: '把想法变成真实的产品/方案，通过迭代验证可行性'
      },
      {
        step: 5,
        title: '激励与反馈',
        icon: '🎁',
        description: '给贡献者奖励、认可，收集改进意见',
        details: '形成正循环，让大家更愿意提出创意，持续改进'
      }
    ]
  },

  // 创意管理原则
  creativePrinciples: {
    title: '创意管理核心原则',
    principles: [
      {
        title: '鼓励创新思维',
        description: '营造开放、包容的创新环境，鼓励大胆想象',
        icon: '🧠'
      },
      {
        title: '快速验证',
        description: '通过MVP快速验证创意可行性，避免过度投入',
        icon: '⚡'
      },
      {
        title: '持续改进',
        description: '基于反馈不断优化和完善创意',
        icon: '🔄'
      },
      {
        title: '团队协作',
        description: '集思广益，发挥团队智慧和创造力',
        icon: '👥'
      },
      {
        title: '价值导向',
        description: '始终以创造价值为目标，关注实际效果',
        icon: '🎯'
      }
    ]
  }
};
